(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-matched-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("cart-matched-addons")) {
    customElements.define(
      "cart-matched-addons",
      class CartMatchedAddons extends HTMLElement {
        constructor() {
          super();
          this.addEventListener("submit", this.handleSubmit.bind(this));
        }

        getSectionsToRender() {
          const sections = [
            {
              id: "Cart-Icon-Bubble",
              section: "cart-icon-bubble",
              selector: ".shopify-section",
            },
          ];

          if (this.hasAttribute("data-in-drawer")) {
            sections.push({
              id: "Cart-Drawer",
              section: this.dataset.sectionId,
              selector: "#Cart-Drawer-Details",
            });
          } else {
            sections.push({
              id: "Main-Cart",
              section: this.dataset.sectionId,
              selector: "#Main-Cart-Details",
            });
          }

          return sections;
        }

        setLoading(button, loading) {
          button.disabled = loading;
          button.setAttribute("aria-busy", loading ? "true" : "false");
          button.querySelector("[data-add-label]").hidden = loading;
          button.querySelector("[data-loading-label]").hidden = !loading;
        }

        async handleSubmit(event) {
          const form = event.target.closest("form");
          if (!form || !this.contains(form)) return;

          event.preventDefault();
          const button = form.querySelector("button[type='submit']");
          const variantId = form.elements.id.value;
          const sections = this.getSectionsToRender();
          this.setLoading(button, true);

          try {
            const response = await fetch(window.routes.cart_add_url, {
              ...webvista.fetchConfig(),
              body: JSON.stringify({
                items: [{ id: Number(variantId), quantity: 1 }],
                sections: sections.map((section) => section.section),
                sections_url: window.location.pathname,
              }),
            });
            const responseJson = await response.json();

            if (!response.ok || responseJson.errors || responseJson.status) {
              throw new Error(responseJson.description || responseJson.message);
            }

            SectionDynamicUpdate.updateSections(sections, responseJson.sections);
            webvista.popToast(form.dataset.addedMessage, "success");
            webvista.publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "cart-matched-addons",
              productVariantId: variantId,
              cartData: responseJson,
            });

            const cartLine = document
              .querySelector(`[data-variant-id="${variantId}"]`)
              ?.closest(".cart-item");
            const focusTarget = cartLine?.querySelector(".cart-item-name");

            if (focusTarget && this.hasAttribute("data-in-drawer")) {
              const drawerTrap = document.querySelector("#Cart-Drawer [data-trap]");
              webvista.trapFocus(drawerTrap, focusTarget);
            } else {
              focusTarget?.focus();
            }
          } catch (error) {
            webvista.popToast(this.dataset.errorMessage, "error");
            this.setLoading(button, false);
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["diagnostic-tool-prompt"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('diagnostic-tool-prompt')) {
    customElements.define(
      'diagnostic-tool-prompt',
      class DiagnosticToolPrompt extends HTMLElement {
        connectedCallback() {
          this.storageKey = this.dataset.storageKey;
          this.promptLifetime = 14 * 24 * 60 * 60 * 1000;
          this.dismissButton = this.querySelector('[data-diagnostic-dismiss]');
          this.openButton = this.querySelector('[data-diagnostic-open]');
          this.modal = document.getElementById('DiagnosticToolsModal');

          this.dismissButton?.addEventListener('click', () => this.dismiss());
          this.openButton?.addEventListener('click', () => this.open());

          if (this.wasRecentlyShown()) return;

          window.setTimeout(() => this.reveal(), Number(this.dataset.delay) || 9000);
        }

        wasRecentlyShown() {
          try {
            const shownAt = Number(window.localStorage.getItem(this.storageKey));
            return shownAt > 0 && Date.now() - shownAt < this.promptLifetime;
          } catch (error) {
            return false;
          }
        }

        remember() {
          try {
            window.localStorage.setItem(this.storageKey, String(Date.now()));
          } catch (error) {
            return;
          }
        }

        reveal() {
          this.hidden = false;
          this.remember();
        }

        dismiss() {
          this.hidden = true;
          this.remember();
        }

        open() {
          this.remember();
          this.modal?.show(this.openButton);
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
